import { render, staticRenderFns } from "./YourPosition.vue?vue&type=template&id=6189c4a1&scoped=true"
import script from "./YourPosition.vue?vue&type=script&lang=js"
export * from "./YourPosition.vue?vue&type=script&lang=js"
import style0 from "./YourPosition.vue?vue&type=style&index=0&id=6189c4a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189c4a1",
  null
  
)

export default component.exports